import { useState } from "react";
import AppPage from "../AppPage";
import { globals, images } from "../../styles";
import { arrow_Icon, eye_Icon, search_Icon } from "../../assets/icons";
import { useNavigate } from "../../hooks/useNavigate";
import { Page, Uid } from "../../types";
import MenuButtonBar, { MenuBarItem } from "../MenuBottomBar";
import SearchComponent from "../SearchComponent";
import FullscreenModal from "../FullscreenModal";
import ArtistModal from "../ArtistModal";
import { useNewsArticle } from "../../hooks/useNewsArticle";
import big_News from "../../assets/NewsImages/BigImg.png";
import styles from "./NewsPage.module.css";
import {
  sml1_News,
  sml2_News,
  sml3_News,
  sml4_News,
} from "../../assets/NewsImages";
import { isSearchResultArtist, SearchResult } from "../../api/types";

const newsItems = [
  {
    image: big_News,
    headline:
      "Fans Choose Bruno Mars' 'I Just Might' as This Week's Favorite New Music",
    source: "Billboard",
    time: "2 hrs ago",
    size: "big" as const,
  },
  {
    image: sml1_News,
    headline: "Chappell Roan's Love Letter to the LGBTQ Community",
    source: "Billboard",
    time: "2 hrs ago",
    size: "small" as const,
  },
  {
    image: sml2_News,
    headline: "Farm Aid 2025 to Air Live on CNN to Celebrate 40 Years",
    source: "Billboard",
    time: "2 hrs ago",
    size: "small" as const,
  },
  {
    image: sml3_News,
    headline: "Gracie Abrams Set to Make Acting Debut in A24’s ‘Please’",
    source: "Billboard",
    time: "2 hrs ago",
    size: "small" as const,
  },
  {
    image: sml4_News,
    headline: "Jimin's 'Closer Than This' Is Here: Watch the Music Video",
    source: "Billboard",
    time: "2 hrs ago",
    size: "small" as const,
  },
];

function NewsCard(props: {
  index: number;
  image: string;
  headline: string;
  source: string;
  time: string;
  size: "big" | "small";
}) {
  const { index, image, headline, source, time, size } = props;
  const { navigate } = useNavigate();
  const { setArticleIndex, viewedArticles } = useNewsArticle();
  return (
    <button
      className={globals["button-wrapper"]}
      onClick={() => {
        setArticleIndex(index);
        navigate(Page.NewsArticle);
      }}
    >
      <div className={styles[size === "big" ? "news-big" : "news-small"]}>
        <img src={image} alt="" className={images["news-card-image"]} />
        <span className={globals["big-news-headline"]}>{headline}</span>
        <div className={styles["news-info"]}>
          <span className={globals["big-news-source"]}>{source} -</span>
          <span className={globals["big-news-source"]}>{time}</span>
          {viewedArticles.has(index) && (
            <img src={eye_Icon} className={images["news-eye"]} alt="" />
          )}
        </div>
      </div>
    </button>
  );
}

function NewsPage() {
  const { navigate } = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [selectedArtistId, setSelectedArtistId] = useState<Uid | undefined>(
    undefined,
  );

  const handleResultClicked = (res: SearchResult) => {
    if (!isSearchResultArtist(res)) return;
    setSelectedArtistId(res.artistId);
    setSearchOpen(false);
  };

  const handleCloseArtistPage = () => {
    setSelectedArtistId(undefined);
  };

  const [bigItem, ...smallItems] = newsItems;
  const smallRows = [];
  for (let i = 0; i < smallItems.length; i += 2) {
    smallRows.push(smallItems.slice(i, i + 2));
  }

  return (
    <AppPage
      className={globals["page"]}
      bottomBar={
        <MenuButtonBar
          items={[
            MenuBarItem.Home,
            MenuBarItem.Leaderboards,
            MenuBarItem.Groups,
            MenuBarItem.LogOut,
          ]}
        />
      }
    >
      {selectedArtistId && (
        <ArtistModal
          currentArtistId={selectedArtistId}
          isCurrentArtistInLineUp={false}
          isLineupFull={true}
          handleBackToSearch={() => {
            setSelectedArtistId(undefined);
            setSearchOpen(true);
          }}
          handleCloseArtistPage={handleCloseArtistPage}
        />
      )}
      {searchOpen && !selectedArtistId && (
        <FullscreenModal
          onClose={() => setSearchOpen(false)}
          style={{ container: { display: "flex", flexDirection: "column" } }}
        >
          <SearchComponent
            searchType="artist"
            handleResultClicked={handleResultClicked}
            clearOnClick
          />
        </FullscreenModal>
      )}
      <button
        className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
        onClick={() => navigate(Page.Welcome)}
      >
        <div className={globals["back-btn"]}>
          <img src={arrow_Icon} alt="" className={images["back-arrow-icon"]} />
        </div>
      </button>
      <span className={globals["news-heading"]}>News</span>
      <button
        className={globals["button-wrapper"]}
        onClick={() => setSearchOpen(true)}
      >
        <div className={styles["search-trigger"]}>
          <img src={search_Icon} alt="" className={images["search-icon"]} />
          <span className={styles["search-trigger-placeholder"]}>
            Search for Artists!
          </span>
        </div>
      </button>
      <div className={styles["news-scroll"]}>
        <div className={styles["new-big-container"]}>
          <NewsCard index={0} {...bigItem} />
        </div>
        {smallRows.map((row, rowIdx) => (
          <div key={rowIdx} className={styles["new-small-container"]}>
            {row.map((item, colIdx) => (
              <NewsCard
                key={item.headline}
                index={1 + rowIdx * 2 + colIdx}
                {...item}
              />
            ))}
          </div>
        ))}
      </div>
    </AppPage>
  );
}

export default NewsPage;
